<template>
<main>
	<div style="max-width:1200px;margin:0 auto;">
    <div v-if="!urlInvalid">
      <div v-if="creatingEvent" class="card shadow p-4 mt-4 text-center" style="min-height: 601px;">
          <div class="row mt-3">
            <div class="col-12">
              <h4 class="text-secondary">{{$t('lang.calendar.waitplease')}}...</h4>
              <img src="@/assets/images/creatingevent.gif"/>
            </div>
          </div>
      </div>
      <div v-if="newevent && !creatingEvent" class="card shadow p-4 mt-4 text-center" style="min-height: 601px;">
          <div class="w-100" v-if="avatar">
          <img class="rounded-circle border-color img-user mb-3" width="80px" :src="avatar" />
          </div>
          <div class="row mt-3" >
            <div class="col-12">
              <h4>{{$t('lang.calendar.confirmed',{name: name})}}</h4>
            </div>
          </div>

          <div class="row mt-3" >
            <div class="col-12">
              <span>{{$t('lang.calendar.thanks', {firstname: newevent.first_name, email: newevent.email})}}</span>
            </div>
          </div>
          <div class="row mt-3" >
            <div class="col-12">
              <strong class="text-secondary mt-2"><i class="icon-calendar mr-2"></i>{{dayselected[0]}}/{{dayselected[1]}}/{{dayselected[2]}} {{dayselected[3]}}hs.</strong>
            </div>
          </div>
          <div class="row mt-3" >
            <div class="col-12">
              <strong class="text-secondary mt-2"><i class="icon-globe mr-2"></i>
                {{calendar.timezonelabel}}</strong>
            </div>
          </div>
      </div>
      <loadingSpinnerBar v-if="loadingfirst"/>
      <div v-if="!newevent && !creatingEvent" class="card shadow p-4 mt-4">
        <div class="row mt-4" :class="(loadingfirst) ? 'blur':''">

				<div class="col-lg-4" >
					<div class="row mb-2">
						<div class="col-12" v-if="openform">
							<button @click="back()" class="btn btn-primary float-left"><i class="icon-arrow-left mr-2"></i>{{ $t('lang.button.back') }}</button>
						</div>
					</div>
						<div class="w-100" v-if="avatar">
						<img class="rounded-circle border-color img-user mb-3" width="80px" :src="avatar" />
						</div>
						<strong class="text-secondary">{{name}}</strong>
						<h3>{{calendar.title}}</h3>
						<strong class="text-secondary mt-2"><i class="icon-clock mr-2"></i>{{calendar.duration}}</strong>
						<p v-if="calendar.calendar_description" class="mt-3">{{calendar.calendar_description}}</p>
				</div>
				<div class="col-lg-8 border-left pb-4 mb-4" >

              <h5 class="" v-if="!daylabel">{{$t('lang.calendar.selectmonth',{'name':calendar.name})}}</h5>
              <h5 class="" v-if="daylabel && dayselected.length == 0">{{$t('lang.calendar.selectday',{'name':calendar.name,'day':daylabel,'month':$t('lang.label.' + monthlabel )})}}</h5>
              <h5 class="" v-if="daylabel && dayselected.length > 0">{{$t('lang.calendar.selecthour',{'name':calendar.name,'day':daylabel,'month':$t('lang.label.' + monthlabel ),'timezone':calendar.timezonelabel,'hour':dayselected[3]})}}</h5>
              <div class="text-secondary pt-2 " v-if="dayselected.length == 0">
              <i class="icon-arrow-left cursor-pointer
              rounded-circle bg-primary text-white p-2 mr-2"
              @click="nextMonth(currentmonth-1,true)"
              v-if="!loading && fixedyear < theyear || (fixedyear == theyear && fixedmonth < currentmonth )"></i>
              <span>{{$t('lang.label.' + monthlabel )}} {{theyear}}</span>
              <i v-if="!loading" class="cursor-pointer icon-arrow-right ml-2
              rounded-circle text-white bg-primary p-2"
              @click="nextMonth(currentmonth+1,true)"></i>
              <span class="loadingres spinner-border loading-spinner ml-2" v-if="loading"></span>
              </div>
              <Calendar
                @createEvent="createEvent($event)"
                :class="loading ? 'blur':''"
                @open="openForm"
                @showday="showDay($event)"
                @timezone="selectTimeZone($event)"
                :timezones="timezones"
                @eventcreated="eventCreated($event)"
                @nextMonth="nextMonth(currentmonth+1,false)"
                :key="calkey"
                :calendar="calendar"
                :monthlabel="monthlabel" />

          </div>
           <div class="p-2 card mt-3" style="height:120px;overflow-y:scroll;"  v-if="hashash">
							<small v-html="$t('lang.calendar.privacy')">
								
							</small>
</div>

	</div>
      </div>
    </div>
    <div v-else class="d-flex flex-rowcard shadow p-3 m-4 text-center ">
        <div>
        <span><i class="icon-window-close-o text-danger mr-2" style="font-size: 1.5em;"></i></span>
        </div>
        <div>
          <p>{{ $t('lang.label.calendar_not_valid')}}
        </p>
        </div>
    </div>

</div>
</main>
</template>
<script>
import Calendar from "@/components/Calendar/Calendar.vue";
import loadingSpinnerBar from "@/components/LoadingSpinnerBar.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { mapState, mapActions } from "vuex";
import { myCalendarService,lenguagesService,regionsService } from "@/_services";
import i18n from '@/_helpers/i18n';
import Modal from "@/components/Common/Modal.vue";



export default {
	data() {
		return {
		  business_contact_hash: false,
		  campaign_hash:false,
      urlInvalid: false,
			timezone:160,
			creatingEvent:false,
			newevent:false,
			dayselected:[],
			timezones:[],
			daylabel:false,
			openform:false,
			loadingfirst:true,
			name:String,
			avatar:String,
			account_id: String,
			calendar: Object,
			currentmonth:1,
			fixedmonth:1,
			monthlabel:'',
			calkey:12232,
			hashash:false,
			loading:true,
			theyear:2023,
			fixedyear:2023,
			calendar : {
	    		'title' : '30 Minute Meeting',
	    		'duration':'30 min',
	    		'currentmonth': '',
	    		'labelmonth': '',
	    		'labeldays':['mon','tue','wed','thu','fri','sat','sun'],
	    		'days':[],
				'hours':[],
				'name': "",
				'accountId': false,
				'currentmonth': false,
				'currentyear': false,
				'defaultTimezone' : false,
				'timezonelabel': "Europe/Paris"
	    	},
	    	calendarDefault: {
	    		"availability":[0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,0,0,0,0,0,0,0,0,0,0,0],
	    		"avatar":null,
	    		"name":"",
	    		"calendar_description":"",
	    		"duration_minutes":"",
	    		"interval_minutes":0
	    	}
		}
	},
	components: {
		Calendar,
		Modal,
		loadingSpinnerBar,
		LoadingSpinner,
	},
	async created() {
		this.getCalendarParam();

	

    if (typeof this.$route.params.account_id !== "undefined") {
		
    this.$route.params.account_id = this.$route.params.account_id.replace(/=3D/g, "%3D");


    if(this.$route.params.campaign_hash){
    	this.hashash = true
    	this.campaign_hash = this.$route.params.campaign_hash 
    	this.campaign_hash = this.campaign_hash.replace(/=3D/g, "%3D");
    	this.campaign_hash = this.campaign_hash.replace("%20","");
    	this.campaign_hash = decodeURIComponent(this.campaign_hash);
    	this.campaign_hash = this.campaign_hash.replace("  ","");
    	this.campaign_hash = this.campaign_hash.replace(" ","");
    	this.campaign_hash = this.campaign_hash.replace("=","");
    }
    if(this.$route.params.business_contact_hash){
    	this.business_contact_hash = this.$route.params.business_contact_hash 
    	this.business_contact_hash = this.business_contact_hash.replace("%20","");
    	this.business_contact_hash = this.business_contact_hash.replace(/=3D/g, "%3D");
    	this.business_contact_hash = decodeURIComponent(this.business_contact_hash);
    	this.business_contact_hash = this.business_contact_hash.replace("  ","");
    	this.business_contact_hash = this.business_contact_hash.replace(" ","");
    	this.business_contact_hash = this.business_contact_hash.replace("=","");
    }

      const accountValue = decodeURIComponent(this.$route.params.account_id)
	  
      // Check if account_id is base64 valid and this value is number
      if(this.isBase64(accountValue)){
		
        const value = atob(accountValue)

        const isUserCalendarValid = true

        if(!isNaN(value) && isUserCalendarValid){
		
          this.account_id = accountValue

          let d = new Date();
          this.currentmonth = d.getMonth()+1
          console.log("CURRENT MONT "+this.currentmonth )
          this.theyear = d.getFullYear()
          this.fixedyear = d.getFullYear()
          this.fixedmonth = d.getMonth()+1


          let month = ["january","frebruary","march","april","may","june","july","august","september","october","november","december"];
          this.monthlabel = month[this.currentmonth-1]

            lenguagesService.getAll().then((response) => {
                  this.languages = response
            });
						let tz
						regionsService
						.getTimezones()
						.then(
						(response) => {
								this.timezones = response
								tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
								if(tz !== undefined){
										this.selectTimeZoneLabel(tz)
								}

								tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

								if (tz !== undefined && this.calendar.timezone === undefined) {

										let dataZone = tz.split("/");
										setTimeout(() => {
												if(this.completeLoadingCalendar){
													this.timezones.forEach((item) => {
															if (item.label.includes(dataZone[1])) {
																	this.timezone = item.id;
																	this.selectTimeZone(this.timezone)
															}
													});
													return;
												}
										}, 100);
								}
						}
						);



          i18n.locale = "en_US"
          this.loadCalendarField()
          this.loadCalendar(this.calendarDefault);

            myCalendarService.getLanguageId(this.account_id).then((res) => {
            let languages;
			
            let language_id = res;

            lenguagesService.getAll().then(()=>{
				
              this.languages.forEach(item=>{
			
              if(item.id == language_id){
				
                i18n.locale = item.lang_code;
              }
            })
            });

          });

         // this.nextMonth(this.currentmonth+1)

          this.$modal.show("loading");
          }
        else {
          this.urlInvalid = true;
        }
      } else {
        this.urlInvalid = true;
      }



	    if (typeof this.business_contact_hash !== "undefined" && 
	        typeof this.campaign_hash !== "undefined") {
	      myCalendarService.insertActivity(this.campaign_hash,this.business_contact_hash, true, window.location.href);
	    }

      
      }
  	},
	computed: {
		...mapState({
			headerTab: state => state.header.tab,
			isMenuCollapse: state => state.sidebar.isNavOpen,
	        completeLoadingCalendar: (state) => state.optionsList.completeLoadingCalendar
		}),
	},
	methods: {
		...mapActions("header", {
		changeHeaderTab: "changeTab"
		}),
		...mapActions("headertopbar", {
			setCurrentRoute:"setRoute",
			setCurrentRouteChild:"setRouteChild",
		}),
	    ...mapActions("optionsList", {
			getCalendarParam: "getCalendarParam",
	    }),
	    createEvent(data){
	    	this.creatingEvent = true
		    myCalendarService.createEventInCalendar(data).then((res) => {});
		    this.creatingEvent = false
	    },
	    loadCalendarField(){
		    this.calendar = {
		    		'title' : '30 Minute Meeting',
		    		'duration':'30 min',
		    		'currentmonth': this.monthlabel,
		    		'labelmonth': this.$t('lang.label.' + this.monthlabel ),
		    		'labeldays':['mon','tue','wed','thu','fri','sat','sun'],
		    		'days':[],
					'hours':[],
					'name': "",
					'accountId':this.account_id,
					'currentmonth':this.currentmonth,
					'currentyear':this.theyear,
					'defaultTimezone' : this.timezone,
					'timezonelabel': "Europe/Paris"
		    };
	    },
	    showDay(day){
	    	this.daylabel=day
	    },
	    selectTimeZone(timezone){
	    	this.timezone = timezone
	    	this.timezones.forEach((item, key)=>{
				if(item.id == this.timezone){
					this.calendar.timezonelabel = item.label
					this.calendar.defaultTimezone = item.id
					this.calendar.timezone = item.id
					return false;
				}
			})
	    	this.nextMonth(this.currentmonth,false)
	    },
	    selectTimeZoneLabel(label){
	    	this.calendar.timezonelabel=label
		    	this.timezones.forEach((item, key)=>{
					if(item.label.indexOf(this.calendar.timezonelabel) !== -1) {
						this.calendar.timezonelabel = item.label
						this.calendar.defaultTimezone = item.id
						this.timezone = item.id
						return;
					}
				})
				this.nextMonth(this.currentmonth,false)
	            return;

	    },
		eventCreated(model){
			this.newevent = model
		},
		openForm(dayselected){
			this.dayselected = dayselected
			this.openform=true
		},
		back(){
			this.dayselected=[]
			this.openform=false
			this.calkey++
		},
		nextMonth(currentmonth,saveactivity){
			if(currentmonth == 13){
				currentmonth = 1
				this.theyear++
			}
			if(currentmonth == 0){
				currentmonth = 12
				this.theyear--
			}
			this.currentmonth = currentmonth
			let month = ["january","frebruary","march","april","may","june","july","august","september","october","november","december"];
			this.monthlabel = month[currentmonth-1]
			this.getAvailabilityByMonth(currentmonth,this.theyear,this.account_id)

   		if (saveactivity && typeof this.business_contact_hash !== "undefined" && 
	        typeof this.campaign_hash !== "undefined") {
      		myCalendarService.insertActivity(this.campaign_hash, this.business_contact_hash, true, 'Next Month: ' + this.theyear + '/'+currentmonth);
      }

		},
		udpdateHeader(route){
			this.setCurrentRoute({page:route});
		},

		getAvailabilityByMonth(month,theyear,account_id){
		console.log("GET MONTH "+month)
			this.loading = true
			this.calendar.currentmonth = month
			this.calendar.currentyear = theyear
			myCalendarService.getAvailabilityByMonth(month,theyear,account_id,this.timezone).then((res) => {
				if(res){
					
					this.loadCalendar(res)
					this.loading = false
					this.loadingfirst = false
				}else{
				}
			})
		},
		loadCalendar(res){
			this.calendar.days=[]
			this.avatar = res.avatar
			this.name = res.name
			this.calendar.name = res.name
			this.calendar.calendar_description = res.calendar_description
			this.calendar.duration = res.duration_minutes+' min'
			this.calendar.title = res.duration_minutes+' Minute Meeting'
			res.availability.forEach((item, key)=>{
				this.calendar.days.push(item)
			})

			if(this.calendar.days.length == res.availability.length){
				this.calkey++
				this.loading = false
			}

			if(res.language_id){
              this.languages.forEach(item=>{
			
              if(item.id == res.language_id){
                i18n.locale = item.lang_code;
              }
            })
      
			}
		},
    isBase64(value) {
      // Revisar si la cadena solo contiene caracteres válidos
      if (/^[a-zA-Z0-9+/]*={0,2}$/.test(value)) {
          // Revisar si la longitud de la cadena es un múltiplo de 4
          if (value.length % 2 === 0) {
              return true;
          }
      }
    return false;
    },
    async userCalendarAvailable(account_id){
      try {
        const res = await myCalendarService.userCalendarAvailable(account_id)
        return res ? res : false
      } catch (error) {
        console.log(error)
        return false
      }
 	   }
  }

 }
</script>
<style>
	.blur{
	    filter: blur(5px);
	}
</style>
